export default function () {

    document.addEventListener('goshop:cart_action', function (e) {

        var eventItem = e.detail;

        if (eventItem.Add || eventItem.Remove) {

            eventItem.EcommerceItem = JSON.parse(eventItem.EcommerceItemJson);

            console.debug('Event cart_action received: ', e.detail);
            console.debug(`Action was: ${eventItem.Add ? 'ADD' : 'REMOVED'}`);
            console.debug(`Item`, eventItem.EcommerceItem);
            console.debug(`Items SKU`, eventItem.ItemsSKU);

            if (typeof gtag !== 'undefined') {
                gtag('event', eventItem.Add ? 'add_to_cart' : "remove_from_cart", {
                    value: eventItem.EcommerceItem.price,
                    currency: "PLN",
                    items: [eventItem.EcommerceItem]
                });

            }

            if (typeof dataLayer !== 'undefined') {

                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: eventItem.Add ? 'add_to_cart' : "remove_from_cart",
                    ecommerce: {
                        currency: "PLN",
                        value: eventItem.EcommerceItem.price,
                        items: [eventItem.EcommerceItem]
                    }
                });

            }
            if (typeof fbq !== 'undefined') {
                fbq('track', 'AddToCart', {
                    content_type: 'product',
                    currency: "PLN",
                    content_ids: [eventItem.EcommerceItem.item_id]
                });
            }

            if (typeof exponea !== 'undefined' && eventItem.ExponeaCartUpdateJson) {
                var cartUpdate = JSON.parse(eventItem.ExponeaCartUpdateJson);

                cartUpdate.action = eventItem.Add ? 'add' : 'remove';
                cartUpdate.page_type = exponeaPageType();

                exponea.track('cart_update', cartUpdate);
            }

        }


    });

    document.addEventListener('pjax:complete', function () {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'page_view');
        }
    });
}

// Słownik page_type ze starego sklepu (data-page-type) — utrzymuje ciągłość danych
// cart_update w Exponei; body[data-type] ma nową nomenklaturę (detail/listing/mainpage/cart).
function exponeaPageType() {
    var map = { detail: 'product', listing: 'category', mainpage: 'homepage', cart: 'checkout' };

    return map[document.body.getAttribute('data-type')] || '';
}